var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_DataView.js
// module id = 3972
// module chunks = 168707334958949